// project-imports
import { deleteRequest, getRequest, postRequest, putRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - DT INCIDENTS ||============================== //

export async function handleDTIncidents(action: APIAction) {
  switch (action.method) {
    case 'create':
      return postRequest('/dt-incidents', action.data);
    case 'read':
      return getRequest(`/dt-incidents?dt-id=${action.id}`);
    case 'update':
      return putRequest(`/dt-incidents/${action.id}`, action.data);
    case 'delete':
      return deleteRequest(`/dt-incidents/${action.id}`);
    default:
      console.info('[ApiManager > handleApiAction > handleDTIncidents] - Unknown method');
      break;
  }
}
